// Motion the person asked to reduce (prefers-reduced-motion): scrolling made
// in code jumps instead of gliding. CSS animations are cut in index.css.
export const prefersReducedMotion = () => typeof window !== 'undefined' && !!window.matchMedia
  && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/** 'smooth', unless motion is reduced. */
export const scrollBehavior = () => (prefersReducedMotion() ? 'auto' : 'smooth');
